import { render, staticRenderFns } from "./ymsLogisticsChannelModal.vue?vue&type=template&id=2d9c44fe&scoped=true"
import script from "./ymsLogisticsChannelModal.vue?vue&type=script&lang=js"
export * from "./ymsLogisticsChannelModal.vue?vue&type=script&lang=js"
import style0 from "./ymsLogisticsChannelModal.vue?vue&type=style&index=0&id=2d9c44fe&prod&lang=less"
import style1 from "./ymsLogisticsChannelModal.vue?vue&type=style&index=1&id=2d9c44fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c44fe",
  null
  
)

export default component.exports